import React from 'react'
import createReactClass from 'create-react-class';
import _ from 'lodash'
import i18n from 'live/services/i18n'

import { Checkbox, Radio, Tooltip, OverlayTrigger } from 'react-bootstrap'

import FormGroup from 'live/components/forms/ui/form-group'

var SenderModeForm = createReactClass({
    render: function () {
        let { config, handleValidation, validationState, errorsFor } = this.props;

        return (
            <div>
                <h3>Sender</h3>

                <div className="row">
                    <div className="col-md-6">
                        <FormGroup type="text" label={i18n('Username')}
                            name="config.sender_username" value={config.sender_username}
                            onChange={handleValidation}
                            validationState={validationState('config.sender_username')}
                            hasFeedback help={errorsFor('config.sender_username')}/>
                    </div>
                    <div className="col-md-6">
                        <FormGroup type="text" label={i18n('Password')}
                            name="config.sender_password" value={config.sender_password}
                            onChange={handleValidation}
                            validationState={validationState('config.sender_password')}
                            hasFeedback help={errorsFor('config.sender_password')}/>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <FormGroup type="number"
                            label={
                                <span>
                                    <span>Interval </span>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip id="interval">
                                            {i18n('Interval between each attempt to send data to the remote store, in milliseconds.')}
                                        </Tooltip>
                                        }>
                                        <i className="fa fa-question-circle"/>
                                    </OverlayTrigger>
                                </span>
                                }
                            className="event-limit"
                            name="config.sender_interval" value={parseInt(config.sender_interval)}
                            onChange={handleValidation}
                            validationState={validationState('config.sender_interval')}
                            hasFeedback help={errorsFor('config.sender_interval')}/>
                    </div>
                    <div className="col-md-3">
                        <FormGroup type="number"
                            label={
                                <span>
                                    <span>Delay </span>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip id="delay">
                                            {i18n('Size of ignored window at the end of the log, in milliseconds.')}
                                        </Tooltip>
                                        }>
                                        <i className="fa fa-question-circle"/>
                                    </OverlayTrigger>
                                </span>
                                }
                            className="event-limit"
                            name="config.sender_delay" value={parseInt(config.sender_delay)}
                            onChange={handleValidation}
                            validationState={validationState('config.sender_delay')}
                            hasFeedback help={errorsFor('config.sender_delay')}/>
                    </div>
                    <div className="col-md-3">
                        <FormGroup type="number"
                            label={
                                <span>
                                    <span>Window </span>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip id="window">
                                            {i18n('Size of maximum window to be sent, in milliseconds. Must be greater than the sender interval.')}
                                        </Tooltip>
                                        }>
                                        <i className="fa fa-question-circle"/>
                                    </OverlayTrigger>
                                </span>
                                }
                            className="event-limit"
                            name="config.sender_window" value={parseInt(config.sender_window)}
                            onChange={handleValidation}
                            validationState={validationState('config.sender_window')}
                            hasFeedback help={errorsFor('config.sender_window')}/>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <FormGroup type="number" label="Connect Timeout"
                            className="event-limit"
                            name="config.sender_connect_timeout" value={parseInt(config.sender_connect_timeout)}
                            onChange={handleValidation}
                            validationState={validationState('config.sender_connect_timeout')}
                            hasFeedback help={errorsFor('config.sender_connect_timeout')}/>
                    </div>
                    <div className="col-md-3">
                        <FormGroup type="number" label="Request Timeout"
                            className="event-limit"
                            name="config.sender_request_timeout" value={parseInt(config.sender_request_timeout)}
                            onChange={handleValidation}
                            validationState={validationState('config.sender_request_timeout')}
                            hasFeedback help={errorsFor('config.sender_request_timeout')}/>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = SenderModeForm;
